import MyGoogleMap from 'javascripts/modules/google-map';

class ModuleBlockMap {

	constructor(){
		this._init();
	}

	_init(){
		this.trigger = document.querySelectorAll(`[data-map = 'module-block-map']`);

		for(const mapModule of this.trigger){
			const mapModuleID = mapModule.getAttribute('data-trigger');
	  	const map = new MyGoogleMap(mapModuleID);
		}
	}

}

export const moduleBlockMap = new ModuleBlockMap();